module.exports = __webpack_public_path__ + "static/img/man-front.f3f35ca.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/parts/UST/man-front.png
// module id = B58B
// module chunks = 3